<template>
  <v-card v-resize="onResize">

    <v-toolbar dark color="primary">
      <v-btn icon dark @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-autocomplete
        autocomplete="off"
        v-model="location"
        :loading="searchLoading"
        :items="locations"
        :search-input.sync="searchSync"
        itemText="formatted_address"
        itemValue="place_id"
        return-object
        cache-items
        hide-no-data
        hide-details
        label="Endereço Ex.: alto da xv"
        prependIcon="mdi-magnify"
        outlined dense
        @input="change"
        class="mx-4"
        flat
        solo-inverted
      >
        <template v-slot:item="data">
          <template v-if="typeof data.item !== 'object' &&
              locations.length > patientAddresses.length">
            <v-list-item-subtitle v-html="data.item" @click.stop="return null" />
          </template>

          <template>
            <v-list-item-content>
              <v-list-item-title v-html="data.item.formatted_address"></v-list-item-title>
            </v-list-item-content>
          </template>
        </template>
      </v-autocomplete>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click="ok">Ok</v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-container fluid class="pa-0 ma-0">
      <v-row class="pa-0 ma-0" >
        <v-col cols="12">
          <GmapMap v-if="marker.lat && marker.lng"
            :options="{
              zoomControl: false,
              mapTypeControl: true,
              scaleControl: true,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: false,
              disableDefaultUi: false
            }"
            :center="{lat: marker.lat, lng: marker.lng}"
            :zoom="15"
            :style="{ width: '100%', height: height + 'px'}"
          >
            <GmapMarker
              :position="{lat: marker.lat, lng: marker.lng }"
              :clickable="true" :draggable="true"
              @dragend="dragend"
            />
          </GmapMap>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import _ from 'lodash';
import bus from '@/plugins/eventBus';

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API,
    region: 'pt',
    language: 'BR',
    libraries: 'places,visualization',
  },
});

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data: () => ({
    location: null,
    locations: [],
    patientAddresses: [],
    searchSync: null,
    searchLoading: false,
    marker: { lat: null, lng: null },
    height: window.innerHeight,
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
  },
  mounted() {
    this.onResize();
  },
  created() {
    this.getCurrentGeoLocation();
    this.getPatientAddress();

    if (this.value && this.value.latitude && this.value.longitude) {
      this.marker.lat = this.value.latitude;
      this.marker.lng = this.value.longitude;
    }
  },
  methods: {
    getPatientAddress() {
      this.searchLoading = true;
      this.$store
        .dispatch('patientAddresses/get', this.user.id)
        .then((addresses) => {
          this.patientAddresses = addresses.map((element) => {
            const el = element;
            el.formatted_address = `${el.street}${el.number ? ',' : ''} ${el.number} - ${el.district}, ${el.city} - ${el.state}, ${el.zip}, Brasil`;
            el.place_id = el.id;
            el.type = 0;
            el.geometry = {};
            el.geometry.location = {};
            el.geometry.location.lat = el.latitude;
            el.geometry.location.lng = el.longitude;
            return el;
          });

          this.locations = this.locations.concat('Meus Endereços', this.patientAddresses, 'Endereços Econtrados');
        })
        .catch((err) => {
          bus.$emit('message', {
            message: err.response.data.message,
            type: 'error',
          });
        })
        .finally(() => {
          this.searchLoading = false;
        });
    },
    searchLocation(vl) {
      if (vl) {
        const self = this;
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${vl}&region=br&key=${process.env.VUE_APP_GOOGLE_API}`;
        this.searchLoading = true;

        fetch(url)
          .then((res) => {
            if (res.status === 200) {
              res.json().then((data) => {
                const results = data.results.map((element) => {
                  const el = element;
                  el.type = 1;
                  return el;
                });

                self.locations = self.locations.concat(results);
              });
            }
          })
          .finally(() => {
            this.searchLoading = false;
          });
      }
    },
    async change() {
      if (this.location !== '' && (!this.location.latitude || !this.location.longitude)) {
        await this.getGeolocation(`address=${this.location.formatted_address}`);
      }
      this.marker.lat = Number(this.location.latitude);
      this.marker.lng = Number(this.location.longitude);
      this.$emit('input', this.marker);
    },
    getGeolocation(query) {
      const url = `https://maps.googleapis.com/maps/api/geocode/json?${query}&key=${process.env.VUE_APP_GOOGLE_API}`;

      return fetch(url)
        .then((res) => {
          if (res.status === 200) {
            return res.json().then((data) => {
              this.location.latitude = `${data.results[0].geometry.location.lat}`;
              this.location.longitude = `${data.results[0].geometry.location.lng}`;
            });
          }
          return null;
        });
    },
    getCurrentGeoLocation() {
      // do we support geolocation
      if (!('geolocation' in navigator)) {
        this.errorStr = 'Geolocation is not available.';
        return;
      }

      // get position
      navigator.geolocation.getCurrentPosition((pos) => {
        this.marker.lat = pos.coords.latitude;
        this.marker.lng = pos.coords.longitude;
      }, (err) => {
        this.errorStr = err.message;
      });
    },
    dragend(pos) {
      this.marker = { lat: pos.latLng.lat(), lng: pos.latLng.lng() };
      this.$emit('input', { lat: this.marker.lat, lng: this.marker.lng });
    },
    ok() {
      this.$emit('ok', this.marker);
    },
    onResize() {
      this.height = window.innerHeight - 88;
    },
  },
  watch: {
    searchSync: {
      // eslint-disable-next-line no-undef
      // eslint-disable-next-line func-names
      handler: _.debounce(function (vl) {
        const found = this.locations.find(el => el.formatted_address === vl);
        if (!found && vl && vl.length > 3) {
          this.searchLocation(vl);
        }
      }, 800),
    },
  },
};
</script>
